const LEGACY_KEY_PREFIX = /^cartographer(?=[_.-])/;
const CURRENT_KEY_PREFIX = 'atlas';
const RETIRED_KEYS = ['atlas_guestMode', 'atlas_guestInfo'];

type StorageGetter = () => Storage;

const browserStorages: StorageGetter[] = [
  () => window.localStorage,
  () => window.sessionStorage,
];

function listLegacyKeys(storage: Storage): string[] {
  const legacyKeys: string[] = [];
  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index);
    if (key !== null && LEGACY_KEY_PREFIX.test(key)) {
      legacyKeys.push(key);
    }
  }
  return legacyKeys;
}

/**
 * Moves every `cartographer_*`, `cartographer.*` and `cartographer-*` key to the
 * matching `atlas` key. An existing `atlas` value wins; the legacy key is always removed.
 * Retired keys are then removed.
 */
export function migrateStorageKeys(storage: Storage): void {
  listLegacyKeys(storage).forEach((legacyKey) => {
    const currentKey = legacyKey.replace(LEGACY_KEY_PREFIX, CURRENT_KEY_PREFIX);
    const legacyValue = storage.getItem(legacyKey);
    const currentKeyIsAbsent = storage.getItem(currentKey) === null;

    if (currentKeyIsAbsent && legacyValue !== null) {
      storage.setItem(currentKey, legacyValue);
    }
    storage.removeItem(legacyKey);
  });
  RETIRED_KEYS.forEach((key) => storage.removeItem(key));
}

export function migrateBrowserStorageKeys(storages: StorageGetter[] = browserStorages): void {
  storages.forEach((getStorage) => {
    try {
      migrateStorageKeys(getStorage());
    } catch {
      // The browser blocks or limits this storage area; leave its keys unchanged.
    }
  });
}
